import { Component, OnInit } from '@angular/core';
import { ProfileStatusService } from 'src/app/profiles/profile-status/profile-status.service';
import { SelectItem } from 'primeng/api';
import { ProfileStatus } from 'src/app/profiles/profile-status/profile-status.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { ProfileAdvancedSearchParams } from '../../profile-advanced-search-params.model';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-set-status-search-action',
  templateUrl: './set-status-search-action.component.html',
  styleUrls: ['./set-status-search-action.component.less'],
    standalone: false
})
export class SetStatusSearchActionComponent implements OnInit {
  public valid = false;
  public profileStatuses = [];
  public selectedStatusId = 0;
  constructor(
    private _notifyService: NotificationService,
    private _profileStatusService: ProfileStatusService,
    private _profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this._profileStatusService.getProfileStatuses({ PageNumber: 0, PageSize: 0 }).then((data) => {
      this.profileStatuses = (data.Result as Array<ProfileStatus>).map<SelectItem>((x) => {
        return { label: x.MemberType1, value: x.ID };
      });
    });
  }

  public massSetStatus(searchParams: ProfileAdvancedSearchParams) {
    this._profileService.setProfilesStatusAdvanced(searchParams, this.selectedStatusId).then(() => {
      this._notifyService.translateSuccess('profiles.search.set-status-success');
    });
  }

  public setStatus(profileIds: Array<number>) {
    this._profileService
      .setProfilesStatus(profileIds, this.selectedStatusId)
      .then(() => {
        this._notifyService.translateSuccess('common.success');
      })
      .catch((error) => {
        this._notifyService.httpError(error);
      });
  }
}
